var module = angular.module('octopusApp.projects');

module.directive('actionEditor', function($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      action: '=',
      step: '=',
      project: '=',
      feeds: '=',
      viewOptions: '=',
      localNames: '='
    },
    templateUrl: 'areas/projects/views/action_editor.html',
    link: function(scope, element) {
      var reload = function() {
        
        var action = scope.action;
        var step = scope.step;
        if (!action || !step) {
          return;
        }

        var plugin = pluginRegistry.getDeploymentAction(action.ActionType);
        if (!plugin) {
          octopusLog.error("Unknown action type: ", action.ActionType);
          return;
        }

        var viewTemplateUrl = plugin.editTemplateUrl;
        var template = $templateCache.get(viewTemplateUrl);
        if (!template) {
          octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
          return;
        }

        if (plugin.preLink) {
          plugin.preLink(scope);
        }

        var child = $compile(template)(scope);

        // If it is a new action
        if (!action.Id) {
          
          // Enable any permanent or initial features
          if (plugin.features) {
            
            var enabledFeatures = [];
            
            if (plugin.features.permanent) {
              _.each(plugin.features.permanent, function(feature){
                var featurePlugin = pluginRegistry.getFeature(feature);
                featurePlugin.enable(action);
                enabledFeatures.push(feature);
              });
            }
            
            if (plugin.features.initial) {
             _.each(plugin.features.initial, function(feature){
                var featurePlugin = pluginRegistry.getFeature(feature);
                featurePlugin.enable(action);
                enabledFeatures.push(feature);
             });
            }
            
            action.Properties["Octopus.Action.EnabledFeatures"] = enabledFeatures.join(","); 
          }
        }
        
        if (plugin.editLink) {
          plugin.editLink(scope, child, action);
        }

        var actionBody = $('.action-details', element);
        actionBody.html('');
        actionBody.html(child);
      };

      scope.$watch("action", function() {
        reload();
      });

    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_editor.js
// module id = 6261206498739682
// module chunks = 1